import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRedirectResult } from 'firebase/auth';
import { auth } from '../auth/firebase';
import { reportGoogleAdsSignupIfNewAccount } from '../services/telemetry';

/**
 * Lands here after an OAuth provider redirects back (the popup-blocked
 * fallback path in `SocialAuthButtons`). `getRedirectResult` finalizes the
 * handshake for both new and returning users, then forwards to `/post-auth`
 * for backend provisioning. On failure (or no pending redirect) it returns the
 * user to the sign-in page.
 */
export function SSOCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const result = await getRedirectResult(auth);
        if (result) {
          reportGoogleAdsSignupIfNewAccount(result, { method: 'google.com' });
          navigate('/post-auth', { replace: true });
        } else {
          navigate('/sign-in', { replace: true });
        }
      } catch {
        navigate('/sign-in', { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <main
      className={`
        bg-gray-25 flex min-h-screen items-center justify-center font-[Outfit]
        text-gray-500
      `}
    >
      <p>Signing you in…</p>
    </main>
  );
}
